// extracted by mini-css-extract-plugin
export var actionText = "_sd-4";
export var container = "_sd-0";
export var leftSection = "_sd-1";
export var rightSection = "_sd-2";
export var settingsButton = "_sd-6";
export var settingsIcon = "_sd-7";
export var shortcut = "_sd-5";
export var shortcutGroup = "_sd-3";